import { withNamespaces } from 'react-i18next';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from 'reactstrap';

const CreateRiskAndTaskModal = ({
    t,
    isOpen,
    product,
    isSubmitting,
    onConfirm,
    onCancel,
}) => (
    <Modal isOpen={isOpen} backdrop="static" size="md" toggle={onCancel}>
        <ModalHeader toggle={onCancel}>
            {t('Confirmation Form')}
        </ModalHeader>

        <ModalBody>
            <p className="mb-0">
                {t('Do you want to create the recommended Risk and Task for this packaging product?')}
            </p>

            {product && (
                <p className="text-muted mt-3 mb-0">
                    <strong>{t('Product')}:</strong> {product.product}
                    {product.artNumber ? ` (${product.artNumber})` : ''}
                </p>
            )}
        </ModalBody>

        <ModalFooter>
            <Button
                color="primary"
                type="button"
                size="md"
                disabled={isSubmitting}
                onClick={onConfirm}
            >
                {isSubmitting && (
                    <Spinner className="me-2" animation="border" variant="white" size="sm" />
                )}
                {t('Create')}
            </Button>

            <Button
                color="secondary"
                type="button"
                outline
                size="md"
                disabled={isSubmitting}
                onClick={onCancel}
            >
                {t('Cancel')}
            </Button>
        </ModalFooter>
    </Modal>
);

export default withNamespaces()(CreateRiskAndTaskModal);
